import { PayloadAction } from '@reduxjs/toolkit';
import { quoteApi } from 'api/quote.api';
import { AppActions } from 'store';
import { GetQuoteWithFeeAction, GetQuoteWithoutFeeAction } from 'store/types';

import { call, put } from 'redux-saga/effects';

export function* getQuoteWithoutFeeSaga(
  action: PayloadAction<GetQuoteWithoutFeeAction>
) {
  try {
    const { ...data } = yield call(
      async () => await quoteApi.getQuoteWithoutFee(action.payload.input)
    );
    yield put(AppActions.quoteV2.getQuoteWithoutFeeSuccess(data));
    if (action.payload.next) {
      action.payload.next(data, action.payload.direction);
    }
  } catch (error: any) {
    if (error.response)
      yield put(
        AppActions.quoteV2.getQuoteWithoutFeeFailure(error.response.data)
      );
  }
}

export function* getQuoteWithFeeSaga(
  action: PayloadAction<GetQuoteWithFeeAction>
) {
  try {
    const { ...data } = yield call(
      async () => await quoteApi.getQuoteWithFee(action.payload.input)
    );
    yield put(AppActions.quoteV2.getQuoteWithFeeSuccess(data));
    if (action.payload.next) {
      action.payload.next(data, action.payload.direction);
    }
  } catch (error: any) {
    if (error.response)
      yield put(AppActions.quoteV2.getQuoteWithFeeFailure(error.response.data));
  }
}
